import { NOTE_ACTION_REGISTRY, getNoteActionDefinition } from "../constants/noteActionRegistry";

export const NOTE_ACTIVITY_FILTERS = [
  { value: "all", label: "All activity" },
  { value: "discussion", label: "Discussion" },
  { value: "emails", label: "Emails" },
  { value: "cart", label: "Cart changes" },
  { value: "production", label: "Production" },
  { value: "sales", label: "Sales / CRM" },
];

export const noteMatchesActivityFilter = (action, filter = "all") => {
  if (filter === "all") return true;
  const definition = getNoteActionDefinition(action);
  if (!definition) return false;
  if (filter === "discussion") {
    return definition.action === "written-project-note" || String(definition.scope).includes("comment");
  }
  if (filter === "emails") return String(definition.scope).includes("email");
  if (filter === "cart") return definition.scope === "cart";
  if (filter === "production") return definition.bucket === "production" || definition.scope === "production";
  if (filter === "sales") return definition.bucket === "sales";
  return true;
};

export const isCartNoteAction = (action) => getNoteActionDefinition(action)?.scope === "cart";

export const filterCompanyUpdates = (updates = [], { activityFilter = "all", hideCartChanges = true } = {}) => (
  updates.filter((update) => (
    (!hideCartChanges || !isCartNoteAction(update.action))
    && noteMatchesActivityFilter(update.action, activityFilter)
  ))
);

export const companyUpdateFilterParams = ({ activityFilter = "all", hideCartChanges = true } = {}) => {
  const params = {};
  if (activityFilter !== "all") {
    params.actions = NOTE_ACTION_REGISTRY
      .filter((definition) => noteMatchesActivityFilter(definition.action, activityFilter))
      .map((definition) => definition.action)
      .join(",");
  }
  if (hideCartChanges) {
    params.excludeActions = NOTE_ACTION_REGISTRY
      .filter((definition) => definition.scope === "cart")
      .map((definition) => definition.action)
      .join(",");
  }
  return params;
};
